function createObserver(el, binding) {
  const delay = binding.value && binding.value.delay ? binding.value.delay : 0;
  const threshold = binding.value && binding.value.threshold !== undefined
    ? binding.value.threshold
    : 0.12;

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          setTimeout(() => {
            el.classList.add('is-visible');
          }, delay);
          if (binding.modifiers.repeat !== true) {
            observer.unobserve(el);
          }
        } else if (binding.modifiers.repeat) {
          el.classList.remove('is-visible');
        }
      });
    },
    {
      threshold,
      rootMargin: '0px 0px -40px 0px',
    }
  );

  observer.observe(el);
  el._scrollRevealObserver = observer;
}

export default {
  inserted(el, binding) {
    const className = binding.arg || 'scroll-reveal';
    el.classList.add(className);
    createObserver(el, binding);
  },
  unbind(el) {
    if (el._scrollRevealObserver) {
      el._scrollRevealObserver.disconnect();
      delete el._scrollRevealObserver;
    }
  },
};



// WEBPACK FOOTER //
// ./src/directives/scrollReveal.js